export default "__VITE_ASSET__B3bDZLnj__"